/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */

import {
  DescargarArchivoDocumentacionClinica,
  DescargarArchivoGeneral,
  ObtenerSolicitudesExportacion,
  DescargarZip,
} from "../apis";
import axios from "axios";
import { saveAs } from "file-saver"; // npm install file-saver
import {
  iniciarCarga,
  actualizarProgreso,
  cargaExitosa,
  cargaFallida,
  reset,
} from "./downloadSlice";
import { store } from "../store";

export const descargarDocumetacionGeneral = (ruta) => async (dispatch) => {
  const token = store.getState().login.token;
  dispatch(iniciarCarga());
  let progreso = 0;
  const interval = setInterval(() => {
    progreso += 5;
    if (progreso <= 90) {
      dispatch(actualizarProgreso(progreso));
    }
  }, 200);

  const header = {
    headers: {
      "Content-Type": "application/octet-stream",
      Authorization: `Bearer ${token}`,
    },
    responseType: "blob",
  };

  const rutaBase64 = btoa(
    new TextEncoder().encode(ruta).reduce((acc, byte) => acc + String.fromCharCode(byte), "")
  );

  try {
    const response = await axios.get(
      DescargarArchivoGeneral().concat("?rutaArchivo=").concat(rutaBase64),
      header
    );
    clearInterval(interval);
    dispatch(cargaExitosa(null));
    const blob = new Blob([response.data], { type: response.headers["content-type"] });
    const filename = extractFilename(response.headers["content-disposition"]);
    saveAs(blob, filename);
  } catch (error) {
    clearInterval(interval);
    dispatch(cargaFallida(error.message));
  }
};

export const decargarArchivoClinico = (id) => async (dispatch) => {
  const token = store.getState().login.token;
  dispatch(iniciarCarga());
  let progreso = 0;
  const interval = setInterval(() => {
    progreso += 5;
    if (progreso <= 90) {
      dispatch(actualizarProgreso(progreso));
    }
  }, 200);

  const header = {
    headers: {
      "Content-Type": "application/octet-stream",
      Authorization: `Bearer ${token}`,
    },
    responseType: "blob",
  };

  try {
    const response = await axios.get(
      DescargarArchivoDocumentacionClinica().concat("/").concat(id),
      header
    );
    clearInterval(interval);
    dispatch(cargaExitosa(null));
    const blob = new Blob([response.data], { type: response.headers["content-type"] });
    const filename = extractFilename(response.headers["content-disposition"]);
    saveAs(blob, filename);
  } catch (error) {
    clearInterval(interval);
    dispatch(cargaFallida(error.message));
  }
};

export const extractFilename = (header) => {
  if (!header) return "archivo_descargado";

  const matchFilename = header.match(/filename\s*=\s*["']?([^"';\n]*)["']?/i);
  if (matchFilename && matchFilename[1]) {
    return matchFilename[1];
  }

  return "archivo_descargado";
};

export const decargarExcelSolicitudes = (ids) => async (dispatch) => {
  const token = store.getState().login.token;
  dispatch(iniciarCarga());
  let progreso = 0;
  const interval = setInterval(() => {
    progreso += 5;
    if (progreso <= 90) {
      dispatch(actualizarProgreso(progreso));
    }
  }, 200);
  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
  };
  var resonseData = null;
  const data = {
    idsSolicitud: ids,
  };
  try {
    const response = await axios.post(ObtenerSolicitudesExportacion(), data, header);
    clearInterval(interval);
    dispatch(cargaExitosa(null));
    if (response.data.code === "Ok") {
      resonseData = response.data.data;
    } else {
      resonseData = null;
    }
  } catch (error) {
    clearInterval(interval);
    dispatch(cargaFallida(error.message));
  }

  return resonseData;
};

export const descargaZip = (idSolicitud) => async (dispatch) => {
  const token = store.getState().login.token;
  const usuario = store.getState().login.usuario;
  //usuario?.idUsuario
  dispatch(iniciarCarga());
  let progreso = 0;
  const interval = setInterval(() => {
    progreso += 5;
    if (progreso <= 90) {
      dispatch(actualizarProgreso(progreso));
    }
  }, 200);

  const header = {
    headers: {
      "Content-Type": "application/octet-stream",
      Authorization: `Bearer ${token}`,
    },
    responseType: "blob",
  };

  try {
    const response = await axios.get(
      DescargarZip().concat("/").concat(idSolicitud).concat("/").concat(usuario?.idUsuario),
      header
    );
    clearInterval(interval);
    dispatch(cargaExitosa(null));
    const blob = new Blob([response.data], { type: response.headers["content-type"] });
    const filename = extractFilename(response.headers["content-disposition"]);
    saveAs(blob, filename);
  } catch (error) {
    clearInterval(interval);
    dispatch(cargaFallida(error.message));
  }
};
